import React from 'react'
import Icon from '../../Icon2/Icon'

const TableLoaderV2 = ({ tableWidth, tableHeight }) => {
    let height = tableHeight ? tableHeight + 'px' : '100%'
    return (
        <div
            className="Table__loader"
            data-test-id="cs-table-loader"
            style={{
                width: tableWidth + 'px',
                height: `calc(${height} - 11.175rem)`
            }}>
            <div className="Table__loader_content">
                <Icon icon="PurpleLoader" className="Table__loader-svg" />
                <div className="Table__loader-desc">Fetching details...</div>
            </div>
        </div>
    )
}

export default TableLoaderV2
